import type { ILocationV2 } from '@sravni/types/lib/locations';

import { getCurrentLocation } from '../selectors/locations';

import { useAppSelector } from './redux';

export function useCurrentRegion(): ILocationV2 {
  return useAppSelector(getCurrentLocation);
}
